import { render } from "./Waiting2.vue?vue&type=template&id=52c70b2a"
import script from "./Waiting2.vue?vue&type=script&lang=js"
export * from "./Waiting2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__